import { Typography } from '../../../../components/common';
import './filterHeader.scss';

interface FilterHeaderProps {
  heading: string;
}

const FilterHeader = ({ heading }: FilterHeaderProps) => {
  return (
    <div className="filter-header-container">
      <div className="icon-heading-container">
        <div className="icon-container">
          <i className="bx bxs-phone"></i>
        </div>
        <Typography variant="subText">{heading}</Typography>
      </div>

      <div className="filter-container">
        <div className="icon-container">
          <i className="bx bx-filter"></i>
          <Typography variant="subHeading-1">Filter</Typography>
        </div>
      </div>
    </div>
  );
};

export default FilterHeader;
